module.exports = "/next-static/_next/static/images/hero_image_small-7156d25500d2fa385ac80c6c9f8761c6.webp";